<template>
  <div class="big mydialog">
    <div class="page_title">区域药房设置（患者）</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="searchbox">
          <el-input
            placeholder="请输入药房名称"
            v-model="hospital_name"
            style="width:240px;margin-right:20px"
            @input="search"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="AddRole"
            :disabled="module_id_array[0]?!module_id_array.includes('436'):false"
          >添加地区绑定药房</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%;min-width:1000px;"
            :header-cell-style="{background:'#F5F5F5'}"
          >
            <el-table-column
              prop="province_city_names"
              label="地区"
            ></el-table-column>
            <el-table-column
              prop="hospital_name"
              label="医院名称"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="400"
            >
              <template slot-scope="scope">
                <el-button
                  @click="edit(scope.row.id)"
                  type="text"
                  size="medium"
                  :disabled="module_id_array[0]?!module_id_array.includes('436'):false"
                >编辑</el-button>
                <el-button
                  @click="del(scope.row.id)"
                  type="text"
                  size="medium"
                  :disabled="module_id_array[0]?!module_id_array.includes('437'):false"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="addhospital"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="dialogbox">
        <div class="align-center">
          <div style="width:120px;text-align:right">药房绑定的地区：</div>
          <el-input
            v-model="province_city_names"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10}"
            style="width:300px"
          ></el-input>
          <el-button
            type="text"
            style="margin-left:10px"
            @click="showarea"
          >选择地区</el-button>
        </div>
        <div
          class="align-center"
          style="margin-top:16px"
        >
          <div style="width:120px;text-align:right">绑定药房：</div>
          <el-select
            v-model="hospital_id"
            placeholder="请选择"
            style="width:300px"
          >
            <el-option
              v-for="item in HospitalList"
              :key="item.value"
              :label="item.hospital_name"
              :value="item.hospital_id"
            ></el-option>
          </el-select>
        </div>
      </div>

      <el-dialog
        width="700px"
        title="选择地区"
        :visible.sync="address"
        append-to-body
      >
        <div style="padding-bottom:20px">
          <div class="areabox">
            <div class="areaitem">
              <div>
                <div
                  v-for="(pro,index) in areaData"
                  :key="index"
                  class="provinceitem"
                >
                  <span
                    @click="choosePro(pro,index)"
                    :style="{color:pro.isChecked?'#1890ff':'#333'}"
                  >{{pro.name}}</span>

                  <span
                    v-for="(city,ind) in pro.city"
                    :key="ind"
                    :style="{color:city.isChecked?'#1890ff':'#999'}"
                    @click="chooseCity(city,pro,index,ind)"
                  >{{city.name}}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            slot="footer"
            class="dialog-footer"
            style="text-align:center;margin-top:20px"
          >
            <el-button
              plain
              @click="address = false"
              style="width:100px"
            >取消</el-button>
            <el-button
              type="primary"
              @click="chooseAdd"
              style="width:100px"
            >确定</el-button>
          </div>
        </div>
      </el-dialog>
      <div style="text-align:left;padding:0 0 20px 140px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="submit"
            style="width:70px"
            size="small"
          >保 存</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import system from '../../../api/system';
import _ from 'lodash';

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      areaData: [],
      HospitalList: [],
      hospital_name: '',
      addhospital: false,
      address: false,
      title: '添加地区绑定药房',
      province_ids: '',
      city_ids: '',
      province_city_names: '',
      hospital_id: '',
      id: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        hospital_name: this.hospital_name
      };
      this.axios
        .post('platform/patient/getHospitalAreaConfigList', data)
        .then((res) => {
          this.tableData = res.data.list;
          this.totalNum = res.data.total;
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //获取省份-城市
    getAreaList() {
      this.axios
        .post('platform/platform/getProvinceCityDistrict')
        .then((res) => {
          let areaData = [];
          areaData = res.data.list;
          areaData.forEach((item) => {
            item.isChecked = false;
            item.city.forEach((city) => {
              city.isChecked = false;
            });
          });
          this.areaData = areaData;
        });
    },
    //获取药房列表
    getHospitalList() {
      this.axios
        .post('platform/hospital/getHospitaList', { page: 1, pageNumber: 100 })
        .then((res) => {
          this.HospitalList = res.data.list.map((item) => {
            item.hospital_name = item.address
              ? item.hospital_name + '(' + item.address + ')'
              : item.hospital_name;
            return item;
          });
        });
    },
    //添加
    AddRole() {
      this.title = '添加地区绑定药房';
      this.hospital_id = '';
      this.province_ids = '';
      this.city_ids = '';
      this.province_city_names = '';
      this.id = 0;
      this.addhospital = true;
    },
    //保存
    submit() {
      if (!this.hospital_id || !this.province_city_names) {
        this.$message.error('请选择区域和药房');
        return false;
      }
      let data = {
        province_ids: this.province_ids,
        city_ids: this.city_ids,
        province_city_names: this.province_city_names,
        hospital_id: this.hospital_id
      };
      if (this.title == '添加地区绑定药房') {
        data.id = 0;
        this.axios
          .post('platform/patient/saveHospitalAreaConfigInfo', data)
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('添加成功');
              this.addhospital = false;
              this.getList();
            }
          });
      } else {
        data.id = this.id;
        this.axios
          .post('platform/patient/saveHospitalAreaConfigInfo', data)
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('修改成功');
              this.addhospital = false;
              this.getList();
            }
          });
      }
    },
    //修改
    edit(id) {
      this.id = id;
      this.title = '编辑地区绑定药房';
      this.addhospital = true;
      this.axios
        .post('platform/patient/getHospitalAreaConfigInfo', { id })
        .then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            this.hospital_id = info.hospital_id;
            this.province_ids = info.province_ids;
            this.city_ids = info.city_ids;
            this.province_city_names = info.province_city_names;
          }
        });
    },
    //删除
    del(id) {
      this.$confirm('您确定删除绑定的药房？', '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/patient/deleteHospitalAreaConfigInfo', { id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除成功');
                if (!(this.tableData.length - 1) % this.pagesize) {
                  this.currentPage =
                    this.currentPage == 1 ? 1 : this.currentPage - 1;
                }
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    //编辑地区弹窗
    showarea() {
      let pro_id = [];
      let city_id = [];

      if (!this.province_ids && !this.city_ids) {
        pro_id = [];
        city_id = [];
      } else {
        pro_id = this.province_ids.split(',');
        city_id = this.city_ids.split(',');
      }

      this.areaData.forEach((item) => {
        item.isChecked = false;
        let a = 0;
        item.name = item.name.replace(/\([^\)]*\)/g, '');
        if (pro_id.includes(item.province_id + '')) {
          item.isChecked = true;
          a = 1;
        }
        item.city.forEach((city) => {
          city.isChecked = false;
          if (city_id.includes(city.city_id + '')) {
            city.isChecked = true;
          }
        });
        if (a) {
          item.isChecked = true;
        }
      });

      this.address = true;
    },

    //选择省
    choosePro(pro, index) {
      pro.isChecked = !pro.isChecked;
      pro.city.forEach((ele) => {
        ele.isChecked = pro.isChecked;
      });
    },
    //选择市
    chooseCity(city, pro, index, ind) {
      pro.isChecked = false;
      city.isChecked = !city.isChecked;
      this.areaData[index].city.forEach((i) => {
        let a = 0;
        if (i.isChecked) {
          a = 1;
        }
        if (a) {
          pro.isChecked = true;
        }
      });
    },
    //选择的地区
    chooseAdd() {
      let proData = [];
      let cityData = [];
      this.areaData.map((pro) => {
        if (pro.isChecked) {
          let a = 0;
          let city_name = '';
          pro.city.map((city) => {
            if (!city.isChecked) {
              a = 1;
            } else {
              city_name += city.name + ',';
            }
          });
          if (a) {
            pro.name =
              pro.name + '(' + city_name.substr(0, city_name.length - 1) + ')';
          }
          proData.push(pro);
        }
        pro.city.map((city) => {
          if (city.isChecked) {
            cityData.push(city);
          }
        });
      });
      let pro_id = [];
      let city_id = [];
      let pros = [];
      pros = proData.map((item) => {
        return item.name;
      });
      pro_id = proData.map((item) => {
        return item.province_id;
      });
      city_id = cityData.map((item) => {
        if (item.isChecked) {
          return item.city_id;
        }
      });
      this.province_ids = pro_id.toString();
      this.city_ids = city_id.toString();
      this.province_city_names = pros.toString();

      this.address = false;
    }
  },

  created() {
    this.getList();
    this.getAreaList();
    this.getHospitalList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
}

.dialogbox {
  box-sizing: border-box;
  padding: 20px;
  text-align: left;
}
.areabox {
  width: 668px;
  height: 446px;
  border: solid 1px #c9cbd6;
  border-bottom: 0px solid #e8e9f0;
  margin: 0 auto;
  margin-top: 20px;
  overflow-y: scroll;
  box-sizing: border-box;

  .areaitem {
    .provinceitem {
      padding: 5px;
      line-height: 30px;
      border-bottom: 1px solid #e8e9f0;
      box-sizing: border-box;
      div {
        margin: 10px 0;
        width: 550px;
      }
      span {
        margin-right: 15px;
        display: inline-block;
        margin-bottom: 5px;
        color: #999;
        cursor: pointer;
      }
      span:first-child {
        color: #333;
        padding-right: 10px;
        border-right: 2px solid #e8e9f0;
        margin-bottom: 5px;
      }
    }
  }
}
</style>
